import { FC } from 'react'

const PackagingIcon: FC = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.125 8.61687L6.875 3.85938"
      stroke="black"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.25 14.6674V7.33406C19.2497 7.01256 19.1648 6.6968 19.0039 6.41846C18.843 6.14011 18.6118 5.90897 18.3333 5.74822L11.9167 2.08156C11.638 1.92065 11.3218 1.83594 11 1.83594C10.6782 1.83594 10.362 1.92065 10.0833 2.08156L3.66667 5.74822C3.38824 5.90897 3.15698 6.14011 2.99609 6.41846C2.8352 6.6968 2.75033 7.01256 2.75 7.33406V14.6674C2.75033 14.9889 2.8352 15.3046 2.99609 15.583C3.15698 15.8613 3.38824 16.0925 3.66667 16.2532L10.0833 19.9199C10.362 20.0808 10.6782 20.1655 11 20.1655C11.3218 20.1655 11.638 20.0808 11.9167 19.9199L18.3333 16.2532C18.6118 16.0925 18.843 15.8613 19.0039 15.583C19.1648 15.3046 19.2497 14.9889 19.25 14.6674Z"
      stroke="black"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 6.38281L11.0025 11.012L19.005 6.38281"
      stroke="black"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 20.24V11"
      stroke="black"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default PackagingIcon
